import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-dev-cards',
  templateUrl: 'cards.component.html',
  styleUrls: ['cards.component.css'],
})

export class CardsComponent {
  constructor() {
  }

  @Input() data: any[] = [{status: 10, descricao: 'tarefa 1'},
    {status: 10, descricao: 'tarefa 2'},
    {status: 20, descricao: 'tarefa 3'},
    {status: 10, descricao: 'tarefa 4'},
    {status: 10, descricao: 'tarefa 5'},
    {status: 10, descricao: 'tarefa 6'},
    {status: 30, descricao: 'tarefa 7'},
    {status: 20, descricao: 'tarefa 8'}
  ];
  @Input() card;
  @Input() cardHeader = 'descricao';
  @Input() className = 'color-cards';
  @Input() page = 1;
  @Output() nextPage: EventEmitter<number> = new EventEmitter<number>();

  OnClick() {
    this.page++;
    this.nextPage.emit(this.page);
  }
}
